<template>
	<!-- Home (Deliveries) page -->
	<Layout>
		<!-- <div class="row">
			<div class="col-12">
				<div class="page-title-box">
					<h4 class="page-title">{{ $t('PORTAL.Deliveries.heading') }}</h4>
				</div>
			</div>
		</div> -->

		<div class="row">
			<div class="col">
				<br />
				<Deliveries :user="currentUser" />
			</div>
		</div>
	</Layout>
</template>

<script>
import { authComputed } from '@/store/helpers'
import Layout from '@/views/layouts/Main.vue'
import Deliveries from '@/components/Deliveries.vue'

const { VUE_APP_ENV } = process.env

export default {
	name: 'Home',
	page: {
		title: `${
			VUE_APP_ENV !== 'prd' ? VUE_APP_ENV.toUpperCase() : ''
		} Deliveries`,
		meta: [{ name: 'description', content: 'Deliveries' }]
	},
	components: {
		Layout,
		Deliveries
	},
	computed: {
		...authComputed
	}
}
</script>
